import {useEffect, useState} from "react";
import {ARRAY_MONTHS_FULL, getFirstWeekStartDate, getLastWeekEndDate} from "../../tools";
import MEventsCalendar from "../components/MEventsCalendar";
import {Button, Col, Row} from "react-bootstrap";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faArrowLeft} from "@fortawesome/free-solid-svg-icons";
import MDayEvents from "../components/MDayEvents";
import {useAppDispatch, useAppSelector} from "../../hooks";
import {
    selectDepartment,
    selectEmployeeCalendarData,
    setCalendarFirstDate,
    setCalendarVisibleDays, setCurrentCalendarData
} from "../../../features/AppStateSlice";
import {RREventType} from "../../types/RREventType";
import MEventDetailsPage from "./MEventDetailsPage";
import {selectCalendar, selectEvents} from "../../../features/AppDataSlice";
import MLogisticsCalendar from "../logistics/MLogisticsCalendar";

const MHomePage = () => {
    const dispatch = useAppDispatch();
    const [selectedDay, setSelectedDay] = useState<Date>(new Date());
    const [selectedEvent, setSelectedEvent] = useState<RREventType | undefined>();
    const calendar = useAppSelector(selectCalendar);
    const events = useAppSelector(selectEvents);
    const activeDepartment = useAppSelector(selectDepartment);
    const firstViewDate = getFirstWeekStartDate(selectedDay);
    const lastViewDate = getLastWeekEndDate(selectedDay);
    const dayDiff = Math.floor((lastViewDate.getTime() - firstViewDate.getTime()) / (1000 * 60 * 60 * 24));
    useAppSelector(selectEmployeeCalendarData);
    useEffect(() => {
        dispatch(setCalendarFirstDate(firstViewDate));
        dispatch(setCalendarVisibleDays(dayDiff));
        dispatch(setCurrentCalendarData({
            data: calendar.data.filter(
                value => (activeDepartment === value.department)
            ),
            events: events.data.filter(
                value => (
                    (activeDepartment === "store" && value.isStore) ||
                    (activeDepartment === "montage" && value.isMontage) ||
                    (activeDepartment === "catering" && value.isCatering)
                )
            )
        }));
    }, [calendar.data, events, selectedDay, dayDiff]);

    return !selectedEvent ?
        <div>
            <Row className={"mb-2"}>
                <Col xs={"auto"} className={"pt-2"}>
                    <Button variant={"outline-dark"}
                            onClick={event => setSelectedDay(new Date(selectedDay.setMonth(selectedDay.getMonth() - 1)))}>
                        <FontAwesomeIcon icon={faArrowLeft}/>
                    </Button>
                </Col>
                <Col className={"border shadow bg-white p-2 rounded"}>
                    <h1 className={"text-center"}>
                        {ARRAY_MONTHS_FULL[selectedDay.getMonth()].toUpperCase()},&nbsp;
                        {selectedDay.getFullYear()}
                    </h1>
                </Col>
                <Col xs={"auto"} className={"pt-2"}>
                    <Button variant={"outline-dark"}
                            onClick={event => setSelectedDay(new Date(selectedDay.setMonth(selectedDay.getMonth() + 1)))}>
                        <FontAwesomeIcon icon={faArrowLeft} style={{transform: "scaleX(-1)"}}/>
                    </Button>
                </Col>
            </Row>

            {
                activeDepartment === "logistics" ?
                    <MLogisticsCalendar
                        selectedDay={selectedDay}
                        onDaySelect={setSelectedDay}
                    /> :
                    <>
                        <MEventsCalendar
                            selectedDay={selectedDay}
                            onDaySelect={setSelectedDay}
                        />
                        <MDayEvents
                            selectedDay={selectedDay}
                            onSelectedDayChange={setSelectedDay}
                            onEventClick={setSelectedEvent}
                        />
                    </>
            }

            <div style={{height: "50px"}}>&nbsp;</div>
        </div>
        :
        <div>
            <MEventDetailsPage
                selectedEvent={selectedEvent}
                selectedDate={selectedDay}
                onEventClose={() => setSelectedEvent(undefined)}
            />
        </div>
};

export default MHomePage;
